import { createContext, useContext } from 'react';
import type { DraftInfo } from '@/types/chat';

/** `checking` until the saved drafts have loaded. */
export type DraftSaveState = 'checking' | 'unsaved' | 'saving' | 'saved';

/** Saves the editor's pending changes to the draft; resolving false cancels the project save. */
export type FlushDraft = (draftVersionId: string) => Promise<boolean>;

export interface ProjectChatContextValue {
  projectId: string;
  getDraftSaveState: (draftVersionId: string) => DraftSaveState;
  /** True when a draft saved to the project has been edited since. */
  hasDraftChangedSinceSave: (draftVersionId: string) => boolean;
  /** Call on every edit to a draft. */
  markDraftEdited: (draftVersionId: string) => void;
  saveDraftToProject: (draft: DraftInfo, flushDraft?: FlushDraft) => void;
}

/** Set when the chat is open inside a project, so its drafts can be saved to the project's files. */
export const ProjectChatContext = createContext<ProjectChatContextValue | null>(null);

export const useProjectChatContext = () => useContext(ProjectChatContext);
